import './productManuals.scss';

import { GetDocDisplayName } from '../../utils/GetDocDisplayName';
import React from 'react';
import { useTranslation } from 'react-i18next';

type ProductManualsProps = {
    product: Queries.ProductJsonTemplateFragment;
    lang: string;
    documents: Queries.ProductJsonDocumentsFragment[];
};

export default function ProductManuals(props: ProductManualsProps) {
    const { product, lang, documents } = props;

    const { t } = useTranslation('templatePages');

    return (
        <div className='product-manuals'>
            <h4>{t('manuals')}</h4>
            <ul className='documents-container'>
                {documents &&
                    documents.map((document, index) => (
                        <li key={index}>
                            <div>
                                {GetDocDisplayName(
                                    document,
                                    product.code ? product.code : ''
                                )}
                            </div>
                            <div>
                                <a
                                    className='download-pdf hover-dark-to-light'
                                    rel='noreferrer'
                                    target='_blank'
                                    href={`/file/${String(
                                        document?.[
                                            lang as keyof Queries.ProductJsonDocumentsFragment
                                        ]
                                    )}`}
                                >
                                    {t('download')}
                                </a>
                            </div>
                        </li>
                    ))}
            </ul>
        </div>
    );
}
